export default "__VITE_ASSET__DzZFOvnC__"